<div class="cr-navbar">
  <div class="cr-navbar-left">
    <button type="button" class="cr-icon-btn cr-back" (click)="back.emit()" title="Go back">
      <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
        <path d="M12 4L6 10l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <div class="cr-channel-icon">
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
        <path d="M2 5a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V5z" stroke="currentColor" stroke-width="1.4"/>
        <path d="M2.5 5.5l7.5 5 7.5-5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <div class="cr-title-block">
      <span class="cr-title-label">{{ channelLabel }} template</span>
      <span class="cr-title-name" *ngIf="templateName">
        {{ templateName }}
        <button type="button" class="cr-icon-btn cr-copy-name" (click)="copyTemplateName()" title="Copy name">
          <svg width="13" height="13" viewBox="0 0 20 20" fill="none">
            <rect x="7" y="7" width="10" height="10" rx="1.4" stroke="currentColor" stroke-width="1.4"/>
            <path d="M13 7V4.5A1.5 1.5 0 0011.5 3h-8A1.5 1.5 0 002 4.5v8A1.5 1.5 0 003.5 14H6" stroke="currentColor" stroke-width="1.4"/>
          </svg>
        </button>
      </span>
    </div>

    <!-- RCA-487: cross-channel "Search or create campaign" popover -->
    <div class="cr-channel-search">
      <button
        type="button"
        class="cr-icon-btn cr-channel-search-trigger"
        (click)="toggleChannelSearch()"
        [attr.aria-expanded]="channelSearchOpen"
        aria-label="Search campaigns"
      >
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
          <circle cx="8.7" cy="8.7" r="5.1" stroke="currentColor" stroke-width="1.6"/>
          <path d="m12.6 12.6 4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
      </button>

      <div class="cr-channel-search-backdrop" *ngIf="channelSearchOpen" (click)="closeChannelSearch()"></div>

      <div class="cr-channel-search-popover" *ngIf="channelSearchOpen" role="dialog" aria-label="Search or create campaign">
        <div class="cr-channel-search-input-shell">
          <svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <circle cx="8.7" cy="8.7" r="5.1" stroke="currentColor" stroke-width="1.6"/>
            <path d="m12.6 12.6 4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          </svg>
          <input
            type="text"
            class="cr-input"
            placeholder="Search or create campaign"
            [ngModel]="channelSearchTerm"
            (ngModelChange)="onChannelSearchTermChange($event)"
            autocomplete="off"
          />
          <button
            type="button"
            class="cr-icon-btn cr-channel-search-clear"
            *ngIf="channelSearchTerm"
            (click)="clearChannelSearchTerm()"
            aria-label="Clear search"
          >×</button>
        </div>

        <div class="cr-channel-filter-bar" role="group" aria-label="Filter campaigns by channel">
          <span class="cr-channel-filter-caption">Channel</span>
          <div class="cr-channel-filter-chips">
            <button
              type="button"
              *ngFor="let chip of channelFilterChips"
              class="cr-channel-chip"
              [class.active]="chip.key === activeChannelFilter"
              [class.is-current]="chip.isCurrent"
              [attr.aria-pressed]="chip.key === activeChannelFilter"
              [title]="chip.isCurrent ? chip.label + ' — channel you are editing' : chip.label"
              (click)="selectChannelFilter(chip.key)"
            >
              <span class="cr-channel-chip-label">{{ chip.label }}</span>
              <span class="cr-channel-chip-count">{{ chip.count }}</span>
            </button>
          </div>
        </div>

        <div class="cr-channel-search-results">
          <div class="cr-channel-search-heading" *ngIf="channelSearchMatches.length">
            {{ activeChannelFilter === 'ALL' ? 'All campaigns' : 'Campaigns' }} ({{ channelSearchMatches.length }})
          </div>
          <button
            type="button"
            *ngFor="let match of channelSearchMatches"
            class="cr-channel-search-result"
            (click)="openChannelSearchMatch(match)"
            [title]="'Open ' + match.templateName"
          >
            <span>{{ match.templateName }}</span>
            <small *ngIf="activeChannelFilter === 'ALL'">{{ match.templateType }}</small>
          </button>
          <div class="cr-channel-search-empty" *ngIf="!channelSearchLoading && !channelSearchMatches.length">
            No campaigns match "{{ channelSearchTerm }}".
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="cr-navbar-search">
    <p-autocomplete
      [ngModel]="templateName"
      (ngModelChange)="templateNameChange.emit($event)"
      [suggestions]="suggestions ?? []"
      (completeMethod)="searchTemplate.emit($event)"
      (onSelect)="selectTemplate.emit($event)"
      [placeholder]="namePlaceholder"
      [emptyMessage]="emptyMessage"
      optionLabel="name"
      scrollHeight="400px"
      styleClass="cr-navbar-search-ac"
      inputStyleClass="cr-input"
    >
      <ng-template let-suggestion pTemplate="templateName">
        <div style="white-space: pre-wrap">{{ suggestion.hint }}</div>
      </ng-template>
    </p-autocomplete>
  </div>

  <div class="cr-navbar-actions" *ngIf="idcustom">
    <button type="button" class="cr-btn cr-btn-secondary" (click)="duplicateClick.emit()" [disabled]="duplicateDisabled">
      Duplicate
    </button>
    <button
      type="button"
      class="cr-btn cr-btn-secondary"
      *ngIf="showTranslateButton"
      (click)="translateClick.emit()"
      [disabled]="translateDisabled"
    >
      Translate
    </button>
    <button type="button" class="cr-btn cr-btn-secondary" (click)="exportClick.emit()" [disabled]="exportDisabled">
      Export
    </button>
    <button type="button" class="cr-btn cr-btn-danger" (click)="deleteClick.emit()" [disabled]="deleteDisabled">
      Delete
    </button>

    <span class="cr-navbar-sep"></span>

    <button
      type="button"
      class="cr-btn cr-btn-secondary"
      *ngIf="showConnectCampaign"
      (click)="connectCampaignClick.emit()"
      [disabled]="connectCampaignDisabled"
    >
      Connect to Campaign
    </button>
    <button
      type="button"
      class="cr-btn cr-btn-primary"
      *ngIf="showResponsysButton"
      (click)="saveResponsysClick.emit()"
      [disabled]="saveResponsysDisabled"
    >
      Save to Responsys
    </button>
  </div>
</div>
